export enum ProductPerformanceType {
  CASH = 'CASH',
  REV = 'REV',
  ARR = 'ARR',
}
